import { ServerTransactionStatusEnum, TRANSACTION_TYPES } from '@expane/data'
import { isThisCompletedTransaction, isThisPendingTransaction } from '../checks'

// Якщо це оплата за запис (не через платіжну систему),
//  де можуть бути розділені окремо транзакції оплати товарів
export const isThisBookingTransactionWithConsumables = <
  T extends {
    booking?: Record<string, unknown> | null
    type: number
    typeVariation?: number | null
  },
>(
  transaction: T,
) =>
  Boolean(transaction.booking) &&
  ((transaction.type === TRANSACTION_TYPES.payment.id &&
    transaction.typeVariation === TRANSACTION_TYPES.payment.variations.product.id) ||
    (transaction.type === TRANSACTION_TYPES.paymentInCredit.id &&
      transaction.typeVariation === TRANSACTION_TYPES.paymentInCredit.variations.product.id))

export const isThisRefundTransaction = <T extends { type: number }>(transaction: T): boolean =>
  transaction.type === TRANSACTION_TYPES.refund.id ||
  transaction.type === TRANSACTION_TYPES.refundWithProvider.id

export const isThisCompletedRefundTransaction = <
  T extends { status: ServerTransactionStatusEnum; type: number },
>(
  transaction: T,
): boolean => isThisCompletedTransaction(transaction) && isThisRefundTransaction(transaction)

export const isThisPendingRefundTransaction = <
  T extends { status: ServerTransactionStatusEnum; type: number },
>(
  transaction: T,
): boolean => isThisPendingTransaction(transaction) && isThisRefundTransaction(transaction)
